<template>
  <div>
    <!-- 名前・ステータス -->
    <Section margin align-self-center>
      <v-layout>
        <v-flex xs3>
          <v-subheader>キャンペーン名</v-subheader>
        </v-flex>
        <v-flex xs9 align-self-center>
          <span class="text-no-wrap">{{ form.campaign.name }}</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs3>
          <v-subheader>クリエイティブ種別</v-subheader>
        </v-flex>
        <v-flex xs9 align-self-center>
          <span class="text-no-wrap">{{ creativeType }}</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs3>
          <v-subheader>ステータス</v-subheader>
        </v-flex>
        <v-flex xs9 align-self-center>
          <span class="text-no-wrap">{{ displayStatus }}</span>
        </v-flex>
      </v-layout>
    </Section>

    <!-- 配信メニュー -->
    <Section
      @back="$emit('back')"
      title="配信メニュー"
      margin
      tip-message="メニュー選択に戻る"
    >
      <div class="menu-setting-container">
        <div>
          クリエイティブ種別：{{
            CreativeTypeItems[form.campaign.menu.creativeType]
          }}
        </div>
        <div>
          ターゲティング種別：{{ MenuTypes[form.campaign.menu.menuType] }}
        </div>
      </div>
      <MenuSection
        :menu-id="form.campaign.menuId"
        :menu-list="menuList"
        :cautionMessage="cautionMessage"
        :loading="loadingMenuList"
        @back="$emit('back', 'Menu')"
      />
    </Section>

    <!-- 予算設定 -->
    <BudgetSection :form="form" @back="$emit('back', 'Budget')" />

    <!-- 配信対象 -->
    <div
      :is="`CampaignModalPageConfirm${targetType}Target`"
      :form="form"
      @back="$emit('back', targetType)"
    />

    <!-- クリエイティブ -->
    <CreativeSection
      v-if="creativeVisible"
      :form="form"
      @back="$emit('back', 'Creative')"
    />

    <!-- 高度な設定 -->
    <AdvancedSection
      :form="form"
      :advertiser="advertiser"
      :loading="loadingInventoryListTargetings"
      :inventory-lists="inventoryListTargetings"
      @back="$emit('back', 'Advanced')"
    />
  </div>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'
import MenuSection from '@/components/Shared/Common/FormMenuConfirm'
import BudgetSection from './CampaignModalPageConfirmBudget'
import CampaignModalPageConfirmGeoTarget from './CampaignModalPageConfirmGeoTarget'
import CampaignModalPageConfirmCustomGeoTarget from './CampaignModalPageConfirmCustomGeoTarget'
import CampaignModalPageConfirmRailwayTarget from './CampaignModalPageConfirmRailwayTarget'
import CampaignModalPageConfirmNewspaperTarget from './CampaignModalPageConfirmNewspaperTarget'
import CampaignModalPageConfirmPTATarget from './CampaignModalPageConfirmPTATarget'
import CampaignModalPageConfirmGeoGenomeTarget from './CampaignModalPageConfirmGeoGenomeTarget'
import CampaignModalPageConfirmCustomTarget from './CampaignModalPageConfirmCustomTarget'
import CampaignModalPageConfirmRetargetingTarget from './CampaignModalPageConfirmRetargetingTarget'
import CampaignModalPageConfirmMansionTarget from './CampaignModalPageConfirmMansionTarget'
import CampaignModalPageConfirmOfficeTarget from './CampaignModalPageConfirmOfficeTarget'
import CampaignModalPageConfirmAutomobileTarget from './CampaignModalPageConfirmAutomobileTarget'
import AdvancedSection from './CampaignModalPageConfirmAdvanced'
import CreativeSection from './CampaignModalPageConfirmCreative'
import { mapGetters } from 'vuex'
import { MenuTypes as MenuTypeConstants } from '@/models/Menu/Constants'

const CreativeTypeItems = {
  banner: 'バナー（静止画）',
  'in feed': 'インフィード',
  video: '動画',
}
const MenuTypes = {
  [MenuTypeConstants.Geo]: 'ジオターゲティング',
  [MenuTypeConstants.Newspaper]: '新聞購読率ターゲティング',
  [MenuTypeConstants.Pta]: 'PTAターゲティング',
  [MenuTypeConstants.Automobile]: '自動車ターゲティング',
  [MenuTypeConstants.Mansion]: 'マンションターゲティング',
  [MenuTypeConstants.GeoGenome]: 'GeoGenomeターゲティング',
  [MenuTypeConstants.Railway]: '鉄道ターゲティング',
  [MenuTypeConstants.Retargeting]: 'リターゲティング',
  [MenuTypeConstants.CustomGeo]: 'カスタムジオターゲティング',
  [MenuTypeConstants.Office]: 'オフィスターゲティング',
  [MenuTypeConstants.Custom]: 'カスタムターゲティング',
}

export default {
  name: 'CampaignModalPageConfirm',
  /* eslint vue/no-unused-components: 0 */
  components: {
    Section,
    MenuSection,
    BudgetSection,
    CampaignModalPageConfirmGeoTarget,
    CampaignModalPageConfirmCustomGeoTarget,
    CampaignModalPageConfirmRailwayTarget,
    CampaignModalPageConfirmNewspaperTarget,
    CampaignModalPageConfirmPTATarget,
    CampaignModalPageConfirmGeoGenomeTarget,
    CampaignModalPageConfirmCustomTarget,
    CampaignModalPageConfirmRetargetingTarget,
    CampaignModalPageConfirmMansionTarget,
    CampaignModalPageConfirmOfficeTarget,
    CampaignModalPageConfirmAutomobileTarget,
    AdvancedSection,
    CreativeSection,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    insertionOrder: {
      type: Object,
      default: () => {},
    },
    advertiser: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadingMenuList: false,
      loadingInventoryListTargetings: false,
      creativeTypeItems: [
        { value: 'banner', text: 'バナー（静止画）' },
        { value: 'in feed', text: 'インフィード' },
        { value: 'video', text: '動画' },
      ],
      cautionMessage: '※登録後メニューは変更できません',
      CreativeTypeItems,
      MenuTypes,
    }
  },
  computed: {
    ...mapGetters('account', ['creativeVisible']),
    displayStatus() {
      return this.form.campaign.status === 'active' ? '有効' : '無効'
    },
    menuList() {
      return this.form.menus
    },
    inventoryListTargetings() {
      return this.form.inventoryListTargetings
    },
    creativeType() {
      return this.creativeTypeItems.find(
        type => type.value === this.form.campaign.creativeType,
      ).text
    },
    isGeoMenuSetting() {
      return this.form.campaign.hasGeoMenuSetting
    },
    menuType() {
      return this.form.campaign.menu.menuType
    },
    targetType() {
      switch (this.menuType) {
        case MenuTypeConstants.Geo:
          return 'Geo'
        case MenuTypeConstants.Newspaper:
          return 'Newspaper'
        case MenuTypeConstants.Pta:
          return 'PTA'
        case MenuTypeConstants.Automobile:
          return 'Automobile'
        case MenuTypeConstants.Mansion:
          return 'Mansion'
        case MenuTypeConstants.GeoGenome:
          return 'GeoGenome'
        case MenuTypeConstants.Railway:
          return 'Railway'
        case MenuTypeConstants.Retargeting:
          return 'Retargeting'
        case MenuTypeConstants.CustomGeo:
          return 'CustomGeo'
        case MenuTypeConstants.Office:
          return 'Office'
        case MenuTypeConstants.Custom:
          return 'Custom'
        default:
          return null
      }
    },
  },
  created() {
    this.fetchMenuList()
    if (this.isGeoMenuSetting) {
      this.form.campaign.menuSetting.fetchLocationGroups()
    }
  },
  methods: {
    async fetchMenuList() {
      try {
        this.loadingMenuList = true
        await this.form.fetchMenus()
      } finally {
        this.loadingMenuList = false
      }
    },
  },
}
</script>
<style>
.menu-setting-container {
  padding-top: 10px;
}
</style>
